// Defines an enum of hard-coded strings that correspond to FontAwesome icons
export enum IconTypes {
    ArrowsRotate = "ArrowsRotate",
    AtomSimple = "AtomSimple",
    Bell = "Bell",
    Books = "Books",
    Crosshairs = "Crosshairs",
    Database = "Database",
    Boxes = "Boxes",
    BriefcaseBusiness = "BriefcaseBusiness",
    BuildingColumns = "BuildingColumns",
    Chart = "Chart",
    ChartCircleDollar = "ChartCircleDollar",
    CircleNodes = "CircleNodes",
    CloudDownload = "CloudDownload",
    Code = "Code",
    Coins = "Coins",
    CreditCard = "CreditCard",
    Flag = "Flag",
    FlaskGear = "FlaskGear",
    Globe = "Globe",
    Plug = "Plug",
    Home = "Home",
    LandmarkFlag = "LandmarkFlag",
    Leaf = "Leaf",
    Lightning = "Lightning",
    Lock = "Lock",
    Megaphone = "Megaphone",
    MessageDollar = "MessageDollar",
    Mobile = "Mobile",
    MoneyBill = "Euro",
    MoneyBills = "MoneyBills",
    MoneyBillTransfer = "MoneyBillTransfer",
    Rocket = "Rocket",
    Newspaper = "Newspaper",
    OilWell = "OilWell",
    PieChartCircleDollar = "PieChartCircleDollar",
    PiggyBank = "PiggyBank",
    QuoteLeft = "QuotesLeft",
    Shapes = "Shapes",
    Search = "Search",
    Invest = "Invest",
    SquareList = "SquareList",
    SquarePollHorizontal = "SquarePollHorizontal",
    Star = "Star",
    Tag = "Tag",
    User = "User",
    UserGroup = "UserGroup",
}

export enum LucideIconTypes {
    arrow_left_right = "arrow_left_right",
    building = "building",
    calculator = "calculator",
    coins = "coins",
    dollar_sign = "dollar_sign",
    eye = "eye",
    gavel = "gavel",
    info = "info",
    landmark = "landmark",
    layers = "layers",
    link = "link",
    scale = "scale",
    shield = "shield",
    store = "store",
    trending_up = "trending_up",
    users = "users",
    git_branch = "git_branch",
    gauge = "gauge",
    repeat = "repeat",
    file = "file",
    file_text = "file_text",
}
